import { module } from 'modujs';
import formMixin from '../vue-mixins/formMixin';

export default class extends module {
    init() {
        //Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData('values'))
        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings
        Vue.config.devtools = true

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default)
        const { required, minLength, email, sameAs } = window.validators

        /////////////////////////
        // Import captcha
        const captcha = JSON.parse(this.el.getAttribute('data-captcha'));

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ['${', '}'],

            mixins: [
                formMixin,
            ],

            data: () => {
                return {
                    submitStatus: '',

                    captcha: captcha,

                    lastname: '',
                    firstname: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    region: '',
                    expertise: '',
                    role: '',
                    condition: '',
                    newsletter: true,
                    weeklyNews: true,
                }
            },

            validations: {
                lastname: {
                    required
                },
                firstname: {
                    required
                },
                email: {
                    required,
                    email
                },
                password: {
                    required,
                    minLength: minLength(8)
                },
                confirmPassword: {
                    required,
                    sameAsPassword: sameAs('password')
                },
                region: {
                    required
                },
                expertise: {
                    required
                },
                role: {
                    required
                },
                condition: { sameAs: sameAs( () => true ) }
            },

            created() {
                this.moduleInstance = moduleInstance
                this.initForm !== undefined && this.initForm()
            },

            methods: {}
        })
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
